import type { HawbExitStatus, HawbIssue } from "#/types/manifest";
import { formatHawbIssue } from "#/utils/manifestUtils";
import { Badge } from "@mantine/core";
import { useTranslation } from "react-i18next";

interface ExitStatusBadgeProps {
  status: HawbExitStatus;
  /** Shown after "Issue:" — the first problem names the badge. */
  issues?: HawbIssue[] | null;
}

const COLORS: Record<HawbExitStatus, string> = {
  open: "blue",
  complete: "green",
  issue: "red",
};

/** ⚪ Open · ✅ Complete · 🔴 Issue: <first problem>. */
const ExitStatusBadge = ({ status, issues }: ExitStatusBadgeProps) => {
  const { t } = useTranslation();
  const firstIssue = status === "issue" && issues && issues.length > 0 ? issues[0] : null;
  const label = firstIssue
    ? t("manifests.exitStatus.issueWithReason", { reason: formatHawbIssue(firstIssue, t) })
    : t(`manifests.exitStatus.${status}`);
  return (
    <Badge color={COLORS[status]} variant={status === "issue" ? "filled" : "light"}>
      {label}
    </Badge>
  );
};

export default ExitStatusBadge;
